export default __webpack_public_path__ + "static/media/Ostali 7.a78dcf3a.jpg";